import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const UsoCFDIRedux = createActions({}, {
  prefix: 'USO_CFDI',
  defaultActions: {
    get: true,
  },
})

const { Types, Creators } = UsoCFDIRedux
export const UsoCFDITypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})


export const reducer = createReducer(
  INITIAL_STATE, {}, {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/UsoCFDIRedux.js